export function extractTextFromSlateJsonString(jsonString, maxLength = 100) {
  let parsed;
  try {
    parsed = typeof jsonString === "string" ? JSON.parse(jsonString) : jsonString;
  } catch (e) {
    // JSON 解析失敗，檢查是否為純文字字串
    if (typeof jsonString === "string" && jsonString.trim()) {
      return jsonString.slice(0, maxLength);
    }
    return ""; // 若完全無法處理，回傳空字串
  }

  // 如果解析成功但不是陣列，檢查是否為字串
  if (!Array.isArray(parsed)) {
    if (typeof parsed === "string") {
      return parsed.slice(0, maxLength);
    }
    return "";
  }

  // 處理 Slate JSON 格式
  let result = "";

  const walk = (nodes) => {
    for (const node of nodes) {
      if (result.length >= maxLength) break;

      if (typeof node.text === "string") {
        result += node.text;
      }
      if (Array.isArray(node.children)) {
        walk(node.children);
      }
    }
  };

  walk(parsed);
  return result.slice(0, maxLength);
}
